module.exports = __webpack_public_path__ + "img/TL.acb160ca.png";